import { type QuestionRendererPropsBase } from "features/Library/Common/props";
import { QuestionsMap } from "features/Library/Surveys/SurveyDetails/SurveyContentForm/SurveyProviders/QuestionsMap";
import { type RatingScale, type SurveyQuestion } from "features/Library/Surveys/SurveyDetails/SurveyContentForm/types";
import { type SurveyQuestionType } from "features/Library/Surveys/types/models";

export type SurveyQuestionRendererProps<T> = QuestionRendererPropsBase<SurveyQuestion<T>, T>;

export const SurveyQuestionBuilder = <T extends string & RatingScale>(props: SurveyQuestionRendererProps<T>) => {
  const { question, validatedFieldProps, index, onBlur, onChanged, disabled, propertyNamePrefix } = props;
  const { Component } = QuestionsMap[question.questionType as SurveyQuestionType];

  return (
    <Component
      disabled={disabled}
      index={index}
      onBlur={onBlur}
      onChanged={onChanged}
      question={question.question}
      validatedFieldProps={validatedFieldProps}
      propertyNamePrefix={propertyNamePrefix}
    />
  );
};
